export const AUTH_USER = "AUTH_USER";
export const AUTH_USER_FAIL = "AUTH_USER_FAIL";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT = "LOGOUT";